import { BusinessRole } from '../../../../../types/api/user'
import { PRINT_PLAN_EDIT_ROLES } from '../../../../schedules/flexo/constants/print-plan-edit-roles'

/** Кто может редактировать примечание к заданию на странице «Печать» */
export const NOTE_EDIT_ROLES = [...PRINT_PLAN_EDIT_ROLES, BusinessRole.Printer]
